var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[(!_vm.ActionSetEmployees)?_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"table"}}):_vm._e(),_c('v-app',{staticClass:"l-content",attrs:{"id":"inspire"}},[_c('MainMenu'),_c('NaviBar'),_c('v-main',[_c('Container'),_c('Footer')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }